import { useContext } from "react";

import { FileRecordListingContext } from "../context/FileRecordListingContext";
import { FileRecordListingFilters } from "./useFileRecordListingFilters";

export const useFileRecordListing = () => {
    const {
        items,
        notes,
        totalItems,
        selectedItems,
        setSelectedItems,
        reloadData,
        areNotesLoading,
        areFileRecordsLoading,
        listingConfig
    } = useContext(FileRecordListingContext);

    const getData = async (filters: FileRecordListingFilters): Promise<void> => {
        await reloadData(filters);
    };

    return {
        items,
        notes,
        totalItems,
        isLoading: areFileRecordsLoading,
        areNotesLoading,
        getData,
        selectedItems,
        setSelectedItems,
        listingConfig
    };
};
